import React from "react";
import { ISVG } from "./interface";

const SVG: React.FC<ISVG> = ({
  style = {},
  fill = "var(--tlx-surface-bg-surface)",
  width = 18,
  height = 20,
  className = "",
  viewBox,
}) => (
  <svg
    width={width}
    style={style}
    height={height}
    viewBox={viewBox || "0 0 20 20"}
    xmlns="http://www.w3.org/2000/svg"
    className={`svg-icon ${className || ""}`}
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <path
      d="M8.75 1.25C12.8906 1.25 16.25 2.37305 16.25 3.75V5C16.25 6.37695 12.8906 7.5 8.75 7.5C4.60938 7.5 1.25 6.37695 1.25 5V3.75C1.25 2.37305 4.60938 1.25 8.75 1.25ZM16.25 7.08984V8.75C16.25 10.127 12.8906 11.25 8.75 11.25C4.60938 11.25 1.25 10.127 1.25 8.75V7.08984C2.86133 8.22266 5.81055 8.75 8.75 8.75C11.6895 8.75 14.6386 8.22266 16.25 7.08984ZM16.25 10.8398V12.5C16.25 13.877 12.8906 15 8.75 15C4.60938 15 1.25 13.877 1.25 12.5V10.8398C2.86133 11.9727 5.81055 12.5 8.75 12.5C11.6895 12.5 14.6386 11.9727 16.25 10.8398ZM16.25 14.5898V16.25C16.25 17.627 12.8906 18.75 8.75 18.75C4.60938 18.75 1.25 17.627 1.25 16.25V14.5898C2.86133 15.7227 5.81055 16.25 8.75 16.25C11.6895 16.25 14.6386 15.7227 16.25 14.5898ZM8.75 0C5.69758 0 0 0.734414 0 3.75V16.25C0 19.271 5.70687 20 8.75 20C11.8024 20 17.5 19.2656 17.5 16.25V3.75C17.5 0.728984 11.7931 0 8.75 0Z"
      fill={fill}
    />
  </svg>
);

export default SVG;
